import { render, staticRenderFns } from "./ExhibitionFloorList.vue?vue&type=template&id=948b738a&scoped=true&"
import script from "./ExhibitionFloorList.vue?vue&type=script&lang=js&"
export * from "./ExhibitionFloorList.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionFloorList.vue?vue&type=style&index=0&id=948b738a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948b738a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDataTable,VTabItem})
